export function scrollErrorIntoView(errorClass?: string) {
    const errorContainer = document.querySelector<HTMLInputElement>(errorClass || ".errorfield");
    if (errorContainer !== null) {
        setTimeout(() => {
            errorContainer?.focus({ preventScroll: true });
            errorContainer.scrollIntoView({
                block: "center",
                inline: "center",
                behavior: "smooth",
            });
        }, 100);
    }
}
